import { render, staticRenderFns } from "./CreateNew.vue?vue&type=template&id=436e4992&scoped=true&"
import script from "./CreateNew.vue?vue&type=script&lang=ts&"
export * from "./CreateNew.vue?vue&type=script&lang=ts&"
import style0 from "./CreateNew.vue?vue&type=style&index=0&id=436e4992&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436e4992",
  null
  
)

export default component.exports